import { render, staticRenderFns } from "./ApplePodcastsLink.vue?vue&type=template&id=54d411b3&"
import script from "./ApplePodcastsLink.vue?vue&type=script&lang=js&"
export * from "./ApplePodcastsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports